import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
/**
 * Tuzilma turlari — `@eombor/api` domenidagi `ORG_UNIT_TYPES` bilan bir xil
 * ro'yxat. `LINE` (MTU ichidagi yo'nalish) va `DIVISION` (korxona ichidagi
 * uchastka) DTIL tuzilmasidan keladi; `PMS`, `TCH`, `AO` — korxona turlari.
 */
export const orgUnitTypeSchema = z.enum([
    'MTU',
    'LINE',
    'STATION',
    'DIVISION',
    'PCH',
    'SHCH',
    'ECH',
    'VCHD',
    'VCHN',
    'PMS',
    'PMC',
    'TCH',
    'PDM',
    'SMD',
    'AO',
    'DEPOT',
    'OTHER',
]);
const idRef = z.string().regex(/^\d+$/, 'Identifikator raqamlardan iborat bo\'lishi kerak');
const codeSchema = z
    .string()
    .regex(/^[A-Za-z0-9][A-Za-z0-9._-]{0,39}$/, 'Kod harf/raqam bilan boshlanib, 40 belgidan oshmasligi kerak');
export const orgUnitSchema = z.object({
    id: z.string(),
    code: z.string(),
    /** Ko'rsatiladigan nom — o'zbekcha lotin. */
    name: z.string(),
    /**
     * Boshqa tillardagi nomlar. Faqat DTIL dan kelgan yozuvlarda to'ladi,
     * qo'lda yaratilganlarida `null` bo'ladi — shuning uchun mijoz har doim
     * `name` ga qaytishi kerak.
     */
    nameUzCyrl: z.string().nullable().optional(),
    nameRu: z.string().nullable().optional(),
    nameEn: z.string().nullable().optional(),
    /** Qisqa belgi — "PCH-7", "MTU-5". */
    shortName: z.string().nullable().optional(),
    type: orgUnitTypeSchema,
    parentId: z.string().nullable(),
    mtuId: z.string().nullable(),
    isActive: z.boolean(),
});
export const createOrgUnitSchema = z.object({
    code: codeSchema,
    name: z.string().min(2).max(200),
    type: orgUnitTypeSchema,
    parentId: idRef.nullable().optional(),
    /**
     * Faqat `@ScopeTarget` uchun e'lon qilingan niyat — saqlanadigan `mtuId`
     * har doim ota korxonadan hisoblanadi, mijoz qiymatiga ishonilmaydi.
     */
    mtuId: idRef.nullable().optional(),
});
export const updateOrgUnitSchema = z.object({
    name: z.string().min(2).max(200).optional(),
    isActive: z.boolean().optional(),
});
export const orgUnitQuerySchema = paginationQuerySchema.extend({
    mtuId: idRef.optional(),
    type: orgUnitTypeSchema.optional(),
    search: z.string().max(200).optional(),
});
export const orgUnitTreeQuerySchema = z.object({ mtuId: idRef });
export const createPositionSchema = z.object({
    code: codeSchema,
    name: z.string().min(2).max(150),
});
export const updatePositionSchema = z.object({
    name: z.string().min(2).max(150).optional(),
    isActive: z.boolean().optional(),
});
export const positionQuerySchema = paginationQuerySchema.extend({
    search: z.string().max(200).optional(),
});
//# sourceMappingURL=org-unit.js.map